<app-primary-card class="assessment-cards" size="full">
  <div class="button-panel">
    <button (click)="toggleInstructions()" type="button">
      {{ _showInstructions ? 'Hide' : 'Show' }} Instructions
    </button>
  </div>

  <div class="button-panel">
    <div>
      <input [(ngModel)]="_import" type="text" />
      <button (click)="import()" type="button">import</button>
    </div>
    <div>
      <input [(ngModel)]="_export" type="text" />
      <button (click)="export()" type="button">export</button>
    </div>
  </div>

  <div>Actions taken:</div>
  <div>{{ _actionsTaken | json }}</div>
</app-primary-card>

<app-primary-card
  *ngIf="_showInstructions"
  class="assessment-cards"
  size="full"
>
  <button (click)="toggleInstructions()" type="button">Hide</button>
  <pre>
    Instructions:
    Assessment operates as per the basal ceiling rules, you can see the logic in the section below.
    When the assessment completes the controls will lock. Clear to run again or you can edit.

    If you want to import a pre made quiz copy and paste the text provided and hit the import button.

    If you want to edit the quiz hit the edit button and construct a quiz.

    You can add/remove rows and tap on the questions to change their responses.

    When you're finished you hit the edit button again to leave edit mode.
    Note: Leaving edit mode will clear the "This Session" values.

    If you want to send your scenario hit export and copy the text (CTRL+A, CTRL+C when in the box is easiest).
    </pre
  >
</app-primary-card>

<app-primary-card class="assessment-cards" size="full">
  <div *ngIf="_editMode" class="button-panel">
    <button (click)="addRow()" type="button">Add</button>
    <button (click)="removeRow()" type="button">Remove</button>
  </div>
  <div *ngIf="!_editMode">
    <div *ngIf="!_assessmentComplete" style="text-align: center">
      Assessment In Progress
    </div>
    <div *ngIf="_assessmentComplete" style="text-align: center">
      Assessment Complete!
    </div>
  </div>
  <div class="button-panel">
    <button
      (click)="click(true)"
      [disabled]="_assessmentComplete || _editMode"
      type="button"
    >
      Mostly
    </button>
    <button
      (click)="click(false)"
      [disabled]="_assessmentComplete || _editMode"
      type="button"
    >
      Rarely
    </button>
    <button (click)="clear()" [disabled]="_editMode" type="button">
      Clear
    </button>
    <button (click)="edit()" type="button">Edit</button>
  </div>
  <div>
    <span class="assessment-row">ID</span>
    <span class="assessment-row">Previous Answers</span>
    <span class="assessment-row">This Session</span>
  </div>
  <div *ngFor="let item of _items">
    <span [class.current]="_currItem.id === item.id" class="assessment-row">{{
      item.id
    }}</span>
    <span
      (click)="toggle(item, 'prev')"
      [class.mostly]="item.prevAnswer"
      [class.not-answered]="item.prevAnswer === null"
      [class.rarely]="item.prevAnswer !== null && !item.prevAnswer"
      class="assessment-row"
      >{{ getText(item.prevAnswer) }}</span
    >
    <span
      [class.mostly]="item.currAnswer"
      [class.not-answered]="item.currAnswer === null"
      [class.rarely]="item.currAnswer !== null && !item.currAnswer"
      class="assessment-row"
      >{{ getText(item.currAnswer) }}</span
    >
  </div>
</app-primary-card>
